// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__N830s","head":"Table_head__3Vt5u","col":"Table_col__3DkFT"};